"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioButtonGroup = void 0;
var react_1 = __importDefault(require("react"));
var RadioButtonGroup = /** @class */ (function (_super) {
    __extends(RadioButtonGroup, _super);
    function RadioButtonGroup(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { groupValue: _this.props.groupValue };
        _this.handleGroupChange = _this.handleGroupChange.bind(_this);
        return _this;
    }
    RadioButtonGroup.prototype.render = function () {
        var _a = this.props, childFunction = _a.children, name = _a.name;
        return (react_1.default.createElement(react_1.default.Fragment, null, childFunction({
            name: name,
            groupValue: this.state.groupValue,
            onChange: this.handleGroupChange,
        })));
    };
    RadioButtonGroup.prototype.handleGroupChange = function (event) {
        if (event.target.checked) {
            this.setState({ groupValue: event.target.value });
            if (this.props.onChange)
                this.props.onChange(event.target.value);
        }
    };
    return RadioButtonGroup;
}(react_1.default.Component));
exports.RadioButtonGroup = RadioButtonGroup;
